import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useLazyGetRegistryResultQuery } from 'bxcommon/store/endpoints/resources.endpoints';
import { warningToast } from 'bxcommon/store/slices/toaster.slice';

import { PublicRegistryResult } from './PublicRegistryResult';
import { PublicRegistrySearch } from './PublicRegistrySearch';
import { AdvisorHeader } from '../AdvisorHeader/AdvisorHeader';

import './PublicRegistry.scss';

export const PublicRegistry = () => {
  const { t } = useTranslation();

  const [getRegistryResult] = useLazyGetRegistryResultQuery();

  const countries = useSelector((state) => state.resources.countries);
  const ombudsmanOffices = useSelector((state) => state.resources.ombudsman_options);
  const degrees = useSelector((state) => state.resources.education);
  const predefinedCertificates = useSelector((state) => state.resources.predefined_certificates);
  const finsaCertificates = useSelector((state) => state.resources.finsa_certificates);
  const fieldsOfActivity = useSelector((state) => state.resources.fields_of_activity);
  const result = useSelector((state) => state.registry.result);

  const [loading, setLoading] = useState(false);
  const [searchCompleted, setSearchCompleted] = useState(false);

  const scrollToResult = () => {
    // top 210 to hide heading and description. Showing the result while still allowing to search again.
    window.scrollTo({ top: 210, left: 0, behavior: 'smooth' });
  };

  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      await getRegistryResult(data).unwrap();
      setSearchCompleted(true);
      scrollToResult();
    } catch (err) {
      console.error(err);
      warningToast(t('publicRegistry.errorContent'), t('publicRegistry.errorTitle'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdvisorHeader hideControls>
      <div className="container">
        <div className="row">
          <div className="col-2" />
          <div className="col-8">
            <div className="public-registry">
              <h1
                className="heading heading--primary heading--color-primary public-registry__heading"
                data-testid="public-registry-heading"
              >
                {t('publicRegister')}
              </h1>
              <p
                className="copy copy--color-dark public-registry__description"
                data-testid="public-registry-description"
              >
                {t('publicRegistry.description')}
              </p>
              <PublicRegistrySearch onSubmit={handleSubmit} loading={loading} />
              <PublicRegistryResult
                result={result}
                countries={countries}
                predefinedCertificates={predefinedCertificates.data}
                degreeData={degrees.data}
                ombudsmanOffices={ombudsmanOffices.data}
                fieldsOfActivity={fieldsOfActivity.data}
                finsaCertificates={finsaCertificates.data}
                searchCompleted={searchCompleted}
              />
            </div>
          </div>
          <div className="col-2" />
        </div>
      </div>
    </AdvisorHeader>
  );
};

export default PublicRegistry;
